/**
 * Stripe Connect, org payment settings and donations
 * (integration/openapi.yaml /billing/connect, /billing/payments,
 * /billing/donate, /billing/donations; docs/Decisions.md D44).
 */
import { get, post, put } from '../lib/apiClient';

/** GET /billing/connect/account - org admin */
export const getConnectStatus = () => get('/billing/connect/account');

/** POST /billing/connect/account - org admin: onboarding or dashboard link */
export const createConnectLink = (returnUrl, refreshUrl) =>
  post('/billing/connect/account', { returnUrl, refreshUrl });

/** GET /billing/payments/settings - org admin */
export const getPaymentSettings = () => get('/billing/payments/settings');

/** PUT /billing/payments/settings - org admin; any subset of the settings */
export const updatePaymentSettings = settings => put('/billing/payments/settings', settings);

/** GET /billing/donate/{orgSlug} - public */
export const getDonatePage = orgSlug =>
  get(`/billing/donate/${encodeURIComponent(orgSlug)}`, { auth: false });

/** POST /billing/donations/quote - public */
export const quoteDonation = ({ orgId, amountCents, frequency, paymentMethod, donorCoversFees }) =>
  post(
    '/billing/donations/quote',
    { orgId, amountCents, frequency, paymentMethod, donorCoversFees },
    { auth: false }
  );

/**
 * POST /billing/donations/checkout - public; sends the session token when
 * signed in, so a member donor gets an in-app receipt.
 */
export const createDonationCheckout = ({
  orgId,
  amountCents,
  frequency,
  paymentMethod,
  donorCoversFees,
  successUrl,
  cancelUrl,
}) =>
  post('/billing/donations/checkout', {
    orgId,
    amountCents,
    frequency,
    paymentMethod,
    donorCoversFees,
    successUrl,
    cancelUrl,
  });

/** GET /billing/donations - org admin */
export const listDonations = query => get('/billing/donations', { query });

/**
 * POST /billing/donations/{donationId}/refund - org admin (docs/Decisions.md
 * D58). `amountCents` defaults to everything not yet refunded. The platform
 * keeps its fee. Resolves to `{ donation }`.
 */
export const refundDonation = (donationId, { amountCents, reason } = {}) =>
  post(`/billing/donations/${encodeURIComponent(donationId)}/refund`, {
    ...(amountCents !== undefined ? { amountCents } : {}),
    ...(reason ? { reason } : {}),
  });
